import ProfileInfoContainer from "./ProfileInfo.container";

export {ProfileInfo} from "./ProfileInfo";
export default ProfileInfoContainer;